import React from 'react';
import { Modal, Typography, Button, ModalDialog } from '@mui/joy';
import WifiOffIcon from '@mui/icons-material/WifiOff';

const NetworkAlert = ({ open, onClose }) => {
    return (
        <Modal
            open={open}
            onClose={onClose}
        >
            <ModalDialog
                variant="outlined"
                role="alertdialog"
                aria-labelledby="network-error-modal"
                sx={{
                    maxWidth: 400,
                    borderRadius: 'md',
                    p: 3,
                    boxShadow: 'lg',
                }}
            >
                <WifiOffIcon
                    sx={{
                        fontSize: 40,
                        color: 'danger.400',
                        mb: 2
                    }}
                />
                <Typography
                    id="network-error-modal"
                    component="h2"
                    level="h4"
                    textColor="danger.400"
                    mb={1}
                >
                    Network Error
                </Typography>
                <Typography textColor="text.secondary" mb={3}>
                    Unable to connect to the server. Please check your internet connection and try again.
                </Typography>
                <Button
                    variant="solid"
                    color="danger"
                    onClick={onClose}
                >
                    Close
                </Button>
            </ModalDialog>
        </Modal>
    );
};

export default NetworkAlert; 